import * as z from 'zod';
import { EntityId, Quantity } from '../base-schemas';
import { isoDateTimeToAppTime } from '../base-codecs';
/**
 * Schema for a single availability check result
 */
export const AvailabilityCheckResult = z.array(z.object({
    reservable_product_id: EntityId,
    requested_quantity: Quantity,
    available_quantity: Quantity,
    is_available: z.boolean()
}));
/**
 * Schema for the request body when checking availability
 */
export const CheckAvailabilityRequest = z.object({
    items: z.array(z.object({
        reservable_product_id: EntityId,
        quantity: Quantity,
        start_datetime: isoDateTimeToAppTime.optional(),
        end_datetime: isoDateTimeToAppTime.optional()
    })).min(1)
});
